<template>
  <div>
    <div class="row">
        <div class="col-sm-12">
          <div class="page-title-box">
            <div class="float-right">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                <li class="breadcrumb-item active">Kategori Retribusi</li>
              </ol>
            </div>
            <h4 class="page-title">Kategori Retribusi</h4>
          </div>
        </div>
      </div>

    <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
            <div class="wrapper-table-default">
                <router-link v-if="$store.state.userData.role_name != 'COMPANY OPERATOR'" :to="{ name: 'instanceServicesCreate' }" class="btn btn-success waves-effect waves-light left-action">Tambah Kategori Retribusi</router-link>
                <div class="table-responsive">
                    <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Data Akun</th>
                                <th>Nama Kategori Retribusi</th>
                                <th>Kategori</th>
                                <th>Harga</th>
                                <th v-if="$store.state.userData.role_name != 'COMPANY OPERATOR'">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in dataServices" :key="item.id">
                                <td v-if="item.account_name || item.account_code">
                                    <span v-if="item.account_name">{{item.account_name}}</span> <b v-if="item.account_code">({{item.account_code}})</b>
                                </td>
                                <td v-else>
                                    -
                                </td>
                                <td>
                                    {{item.name}}
                                    <br v-if="item.description">
                                    <span v-if="item.description" style="font-size: 9px; color: #b8bbbd">Deskripsi : {{item.description}}</span>
                                </td>
                                <td>{{item.category_name ? item.category_name : '-'}}</td>
                                <td>{{currency(item.price)}} <span v-if="item.unit">/ {{item.unit}} {{item.unit_type}}</span></td>
                                <td v-if="$store.state.userData.role_name != 'COMPANY OPERATOR'">
                                    <router-link class="btn btn-primary waves-effect waves-light"
                                        v-if="$store.state.userData.role_name != 'COMPANY OPERATOR'"
                                        :to="{ name: 'instanceServicesEdit', params: { id: item.id } }"
                                        >
                                        <i class="fas fa-pen"></i>
                                    </router-link>
                                    <button class="btn btn-danger waves-effect waves-light ml-2" @click.prevent="deleteItem(item.id)"
                                        v-if="$store.state.userData.role_name != 'COMPANY OPERATOR'">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            loading: true,
            dataServices: [],
        }
    },
    methods: {
        // LOAD SERVICE DATA
        loadData() {
            this.loading = true;
            this.$http.get(`${this.API_URL}service`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                this.loading = false;
                const result = response.data;
                
                if(result.success) {
                    this.dataServices = result.data
                    setTimeout(() => {
                        this.dataTableSearch()
                    }, 500);
                }else {
                    this.sAlert('error', result.message)
                }
            })
            .catch(error => {
                this.loading = false;
                this.errorHandler(error)
            });
        },

        // DELETE SERVICE DATA
        deleteItem(id){
            Swal.fire({
            title: 'Apakah anda yakin untuk menghapus ?<br> <b>Data ini memiliki relasi dengan data lainnya, pastikan dengan baik!<b>',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.value) {
                     this.loading = true
                     this.$http.delete(`${this.API_URL}service/delete/${id}`, {
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })
                    .then(() => {
                        this.loadData()
                    })
                    .catch(error => {
                        this.loading = false
                        this.loadData()
                        this.errorHandler(error)
                    });
                }
            })
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>